import React from 'react';
import dayjs from 'dayjs';
import { imgUrl } from 'utils/url';

const STATUS_LABEL = {
  published: 'Published',
  unpublished: 'Unpublished',
  archived: 'Archived',
};

const formatSchedule = (media) => {
  if (media?.type === 'date' && media.start && media.end) {
    return `${dayjs(media.start).format('D MMM YYYY')} - ${dayjs(media.end).format('D MMM YYYY')}`;
  }

  if (media?.type === 'day' && Array.isArray(media.days) && media.days.length) {
    return `${media.days[0].day} - ${media.days[media.days.length - 1].day}`;
  }

  return 'All Day';
};

function MediaOption({ media }) {
  const fileType = (media.fileType || '').split('/')[0];
  const status = (media.status || '').toLowerCase();
  const statusLabel = STATUS_LABEL[status] || media.status || '';
  const screen = media.categoryName || '-';
  const schedule = formatSchedule(media);

  return (
    <div className="dynamic-comp-media-option">
      <div className="dynamic-comp-media-option-thumb">
        {media.logo && fileType === 'image' ? (
          <img src={`${imgUrl}/media/${media.logo}`} alt={media.name} />
        ) : media.logo && fileType === 'video' ? (
          <video preload="metadata">
            <source src={`${imgUrl}/media/${media.logo}`} type="video/mp4" />
          </video>
        ) : (
          <i className="feather-image" />
        )}
      </div>
      <div className="dynamic-comp-media-option-info">
        <div className="dynamic-comp-media-option-name">{media.name}</div>
        <div className="dynamic-comp-media-option-meta">
          <span>{screen}</span>
          {statusLabel && (
            <>
              <span className="dynamic-comp-media-option-meta-sep">•</span>
              <span className={`dynamic-comp-media-status-${status}`}>
                {statusLabel}
              </span>
            </>
          )}
          <span className="dynamic-comp-media-option-meta-sep">•</span>
          <span>{schedule}</span>
        </div>
      </div>
    </div>
  );
}

export default MediaOption;
